import { h } from 'preact'

/**
 * ThinkingBubble — displays extended reasoning content during streaming.
 * Props: { msgId, reasoningText, i18n }
 */
export function ThinkingBubble({ msgId, reasoningText, i18n }) {
  if (!reasoningText) return null

  const placeholder = i18n?.t('ai.thinking.placeholder') || 'Gondolkodás...'
  const label = i18n?.t('ai.thinking.reasoning') || 'Érvelés'

  return (
    <div class="message message-thinking mb-2">
      <div class="d-flex align-items-start" style="min-width:0">
        <div class="message-avatar me-3">
          <i class="bi bi-hourglass-split fs-3 text-info"></i>
        </div>
        <div class="message-content flex-grow-1">
          <div class="message-header d-flex align-items-center mb-2">
            <strong class="me-2">{label}</strong>
          </div>
          <div class="message-text bg-light border border-info p-3 rounded fst-italic text-muted" style="font-size:.9em;line-height:1.6;">
            {reasoningText || placeholder}
          </div>
        </div>
      </div>
    </div>
  )
}
